<template>
	<div id="home-page">

		<landing-banners />

		<section class="services-section" id="h-paquetes">
			<div class="container oversized-container">
				<div class="content">
					<div class="box-tabs">
						<div class="col-sm-4 col-lg-3 col-tab">
							<a v-bind:class="{ active: servTab == 'movi' }" @click="servTab = 'movi'">Movilidad</a>
						</div>

						<div class="col-sm-4 col-lg-3 col-tab">
							<a v-bind:class="{ active: servTab == 'mifi' }" @click="servTab = 'mifi'">MIFI</a>
						</div>

						<div class="col-sm-4 col-lg-3 col-tab">
							<a v-bind:class="{ active: servTab == 'casa' }" @click="servTab = 'casa'">Casa</a>
						</div>
					</div>

					<!-- MOVIL -->
					<movil-component v-if="servTab == 'movi'"></movil-component>
					<!--  -->

					<!-- MIFI -->
					<mifi-component v-if="servTab == 'mifi'"></mifi-component>
					<!--  -->

					<!-- CASA -->
					<casa-component v-if="servTab == 'casa'"></casa-component>
					<!--  -->

				</div>
			</div>
		</section>

		<section class="banners-section">
			<picture>
				<source srcset="public/images/pages/home/banner-promo-1.webp, public/images/pages/home/banner-promo-1-HD.webp 5999w" type="image/webp" >
				<source srcset="public/images/pages/home/banner-promo-1.jpg" type="image/jpeg">
				<img class="img-desktop" src="public/images/pages/home/banner-promo-1.jpg">
			</picture>
			<img class="img-mobile" src="public/images/pages/home/banner-promo-1-m.jpg">
		</section>

		<section class="banners-section">
			<img class="img-desktop" src="public/images/pages/home/banner-promo-2.jpg">
			<img class="img-mobile" src="public/images/pages/home/banner-promo-2-m.jpg">
		</section>

		<section class="products-section">
			<div class="container oversized-container">
				<div class="row">
					<div class="col-12 col-title-s1">
						<h3 class="title">¡Y una nave para tí!</h3>
					</div>

					<div class="col-12 px-0 col-products">

						<swiper class="swiper swiper-prods" :options="prodsOptions">
							<swiper-slide v-for="(product, phInx) in products" :key="'phInx-'+phInx">
								<div class="col-12 sample-product">
									<router-link class="outlined-box" :to="'/equipo/'+product.id">
										<div class="box-image">
											<div class="img">
												<api-img-pristine :comp="product.imagenes_id" />
													<!-- <api-img-pristine -->
													<!-- {{product.imagenes_id}} -->
											</div>
										</div>

										<div class="box-shot-descr">
											<h6 class="name">{{ product.nombre }}</h6>
											<!-- <h6 class="sku">{{ product.sku }}</h6> -->
											<h6 class="price">{{product.precio | currency}} MXN</h6>
											<!-- <h6 class="brand">{{ product.marca }}</h6> -->

											<router-link class="btn-product" :to="'/equipo/'+product.id">Ver producto</router-link>
										</div>
									</router-link>
								</div>
							</swiper-slide>

							<div class="swiper-button-prev" slot="button-prev"></div>
							<div class="swiper-button-next" slot="button-next"></div>
						</swiper>
					</div>

				</div>
			</div>
		</section>

		<LandingComunicados />

	</div>
</template>

<script>
import _ from 'lodash'
import MovilComponent from './services/MovilComponent';
import MifiComponent from './services/MifiComponent';
import CasaComponent from './services/CasaComponent';
import LandingBanners from '../daniel/landing/landing-banners'
import LandingComunicados from '../daniel/landing/landing-comunicados'
import {mapGetters} from 'vuex'
import ApiImgPristine from '../daniel/api-img-pristine.vue';

export default {
	name: 'HomeIndex',

	components: {
		MovilComponent, MifiComponent, CasaComponent, LandingBanners, LandingComunicados, ApiImgPristine
	},

	data(){
		return{
		
			servTab: 'movi',

			banners: [
				{ imageUrl: 'public/images/pages/home/banner-1.jpg', device: 'pc' },
				{ imageUrl: 'public/images/pages/home/banner-2.jpg', device: 'pc' },
				{ imageUrl: 'public/images/pages/home/banner-1.jpg', device: 'movil' },
				{ imageUrl: 'public/images/pages/home/banner-2.jpg', device: 'movil' },
			],

			// products: [
				// { id: 5, image_url: 'public/images/pages/products/product-1.jpg', nombre: 'Celular Samsung A12 5ta generación' },
				// { id: 5, image_url: 'public/images/pages/products/product-2.jpg', nombre: 'Celular Samsung A12 5ta generación'  },
				// { id: 5, image_url: 'public/images/pages/products/product-3.jpg', nombre: 'Celular Samsung A12 5ta generación'  },
				// { id: 5, image_url: 'public/images/pages/products/product-4.jpg', nombre: 'Celular Samsung A12 5ta generación'  },
				// { id: 5, image_url: 'public/images/pages/products/product-3.jpg', nombre: 'Celular Samsung A12 5ta generación' },
				// { id: 5, image_url: 'public/images/pages/products/product-1.jpg', nombre: 'Celular Samsung A12 5ta generación' },
			// ],

			/* == Carousel options == */

			prodsOptions: {
				slidesPerView: 5,

				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},

				breakpoints: {
					1400: {
						slidesPerView: 5
					},
					1100: {
						slidesPerView: 4
					},
					992: {
						slidesPerView: 3
					},
					400: {
						slidesPerView: 2
					},
					1: {
						slidesPerView: 1
					},
				}
			},

		}
	},
	computed: {
		...mapGetters(['catalogosGetProductos']),
		products(){
			return _.filter(this.catalogosGetProductos, item => {
				console.debug(item)
				return true
			})
		}
	}
}
</script>
